import { Pipe, PipeTransform } from '@angular/core';

const HEATING_DEVICE_VARIANTS: { [key: string]: string } = {
  VitosetAqua34S: 'Vitoset Aqua 34S',
  VitosetAqua74S: 'Vitoset Aqua 74S',
  VitosetAqua87S: 'Vitoset Aqua 87S',
  VitosetAqua124S: 'Vitoset Aqua 124S',
  VitosetAqua87SH: 'Vitoset Aqua 87SH',
  VitosetAqua19D: 'Vitoset Aqua 19D',
  VitosetAqua42D: 'Vitoset Aqua 42D',
};

@Pipe({
  name: 'translateEcowaterDeviceVariant',
})
export class TranslateEcowaterDeviceVariantPipe implements PipeTransform {
  transform(value: string): string {
    if (value && HEATING_DEVICE_VARIANTS[value]) {
      return HEATING_DEVICE_VARIANTS[value];
    }

    return value;
  }
}
